// 統一證件號碼驗證（香港 + 澳門）
//
// 自動偵測：香港身份證以字母開頭（驗 checksum）；澳門身份證以數字開頭（只驗格式）。
// 兩者格式互斥，不會碰撞。
//
// 香港：1-2 個字母 + 6 位數字 + 檢驗碼（0-9 或 A）。驗證完整 checksum。
// 澳門：首位 1/5/7 + 6 位主號數字 + 檢驗碼（0-9 或 A，A 代表檢驗值 10）。
//       澳門官方無公開 check digit 演算法，故只驗格式不驗 checksum。

// 去除括號等符號並轉大寫，方便統一比對。
function normalize(str) {
  return String(str || "").toUpperCase();
}

// 香港身份證 checksum 驗證
export function isHKID(input) {
  let str = normalize(input);

  if (str.length < 8)
    return false;

  // 處理括號 e.g. A123456(7) -> A1234567
  if (str.charAt(str.length - 3) === "(" && str.charAt(str.length - 1) === ")")
    str = str.substring(0, str.length - 3) + str.charAt(str.length - 2);

  const hkidPat = /^([A-Z]{1,2})([0-9]{6})([A0-9])$/;
  const matchArray = str.match(hkidPat);
  if (matchArray == null)
    return false;

  const strValidChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  const charPart = matchArray[1];
  const numPart = matchArray[2];
  const checkDigit = matchArray[3];

  let checkSum = 0;
  if (charPart.length === 2) {
    checkSum += 9 * (10 + strValidChars.indexOf(charPart.charAt(0)));
    checkSum += 8 * (10 + strValidChars.indexOf(charPart.charAt(1)));
  } else {
    checkSum += 9 * 36;
    checkSum += 8 * (10 + strValidChars.indexOf(charPart));
  }
  for (let i = 0, j = 7; i < numPart.length; i++, j--)
    checkSum += j * Number(numPart.charAt(i));

  const remaining = checkSum % 11;
  const verify = remaining === 0 ? 0 : 11 - remaining;

  return String(verify) === checkDigit || (verify === 10 && checkDigit === "A");
}

// 澳門身份證格式驗證（首位 1/5/7 + 6 位數字 + 檢驗碼 0-9 或 A）
export function isMacauID(input) {
  const str = normalize(input);
  return /^([157][0-9]{6})([0-9A]|\([0-9A]\))$/.test(str);
}

// 統一入口：香港或澳門其一通過即有效
export function validateID(input) {
  return isHKID(input) || isMacauID(input);
}

export default validateID;
